export const Constants = {
  PUBLICO_ALVO: 1,
  MODALIDADE: 2,
  FONTE: 3,
  TIPO_SIMULADO: 4
}

export default Constants
